/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Offset_TypeInputs */



/**
* | output |
* | --- |
* | "Offset Type" |
*
* @param {Subtitle_Export_Offset_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_offset_type = /** @type {((inputs?: Subtitle_Export_Offset_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Offset_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de décalage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offset-Typ")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di offset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип смещения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de desplazamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("偏移类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフセットタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफसेट प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de deslocamento")
	return /** @type {LocalizedString} */ ("Offset Type")
});